module.exports = __webpack_public_path__ + "static/media/el-ateneo.bdc2c37c.md";